export default __webpack_public_path__ + "media/events-art-1.cecfffa6.svg";